import { useState, useEffect } from "react";

export interface GithubRepo {
  id: number;
  name: string;
  full_name: string;
  html_url: string;
  description: string;
}

export function useGithubRepos() {
  const [repos, setRepos] = useState<GithubRepo[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchRepos() {
      setLoading(true);
      try {
        const response = await fetch(
          `${import.meta.env.VITE_PUBLIC_API_ENDPOINT}/profile/git/repos`,
          {
            credentials: "include",
          }
        );

        if (response.ok) {
          const result = await response.json();
          setRepos(result.data || []);
        } else {
          setError("Failed to fetch repositories");
        }
      } catch (err) {
        setError("Network error");
      } finally {
        setLoading(false);
      }
    }

    fetchRepos();
  }, []);

  return { repos, loading, error };
}
